import { render, staticRenderFns } from "./CommonPatientForm.vue?vue&type=template&id=8e0dc320&scoped=true&"
import script from "./CommonPatientForm.vue?vue&type=script&lang=js&"
export * from "./CommonPatientForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonPatientForm.vue?vue&type=style&index=0&id=8e0dc320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0dc320",
  null
  
)

export default component.exports